export default __webpack_public_path__ + "static/number-one-most-popular-project-df51a301be87272a1ad6598f7eb95c2c.png";